import { Helmet } from 'react-helmet-async';
import { searchContext } from '../context/Context';
import Loader from '../components/Common/Loader';
import AdvancedSearchContainer from '@/components/AdvancedSearch/AdvancedSearchContainer';

export default function AdvancedSearchPage() {
  const { loading, error } = searchContext();

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <div className="error-message">An error occurred: {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <title>DISGENET: Advanced Search</title>
        <meta name="description" content="Advanced search tools for DISGENET." />
      </Helmet>
      <div className="p-4 advanced-research container-view">
        <div className="search-results-container">
          <AdvancedSearchContainer />
        </div>
      </div>
    </>
  );
}
